import {decode, encode} from './encryptions'

/**
 *
 * ==================== setLclStorage =====================
 * = type 1     => set with enc 1                         =
 * = type 2     => set with enc 2                         =
 * ========================================================
 * @param {String} name
 * @param {*} value
 * @param {Object} options
 * @returns new name
 */
const setLclStorage = (name, value, options = {}) => {
  const type = options?.type
  if (type === 1) {
    name = encode(name)
    localStorage.setItem(name, value)
    return name
  }
  if (type === 2) {
    value = encode(value)
    localStorage.setItem(name, value)
    return name
  }
  localStorage.setItem(name, value)
  return name
}

/**
 *
 * ==================== getLclStorage =====================
 * = type 1     => get with enc 1                         =
 * = type 2     => get with enc 2                         =
 * ========================================================
 * @param {String} name
 * @param {Object} options
 * @returns new value
 */
const getLclStorage = (name, options = {}) => {
  const type = options?.type
  if (type === 1) {
    name = decode(name)
    return localStorage.getItem(name)
  }
  if (type === 2) {
    return decode(localStorage.getItem(name))
  }
  return localStorage.getItem(name)
}

export {setLclStorage, getLclStorage}
